<template>
  <div>
    <Banner theme="orange">
      <template v-slot:title> Venue Events Lists </template>
      <template v-slot:description>
        Venue Events Lists show upcoming events with previews and links to more
        details.
      </template>
    </Banner>

    <IndexPageActions
      :sort-list="sortList"
      btn-text="New Venue Events List"
      btn-to="/widgets/venue-events-lists/new"
      :sort-by.sync="sortBy"
      search-placeholder="Search Venue Events List"
      :search-text.sync="searchText"
    />

    <div v-if="list">
      <VenueEventsListDataTable
        v-if="computedList.length"
        :list="computedList"
        @destroy="destroy"
        @duplicate="duplicate"
      />
      <div v-else class="no-entries">No Venue Events Lists</div>
    </div>
    <Spinner v-else relative />
  </div>
</template>

<script>
import IndexPage from "../index-page";
import VenueEventsListDataTable from "@/components/dataview/venue-events-lists.datatable";

export default {
  name: "WidgetVenueEventsListsPage",
  components: { VenueEventsListDataTable },
  extends: IndexPage,
  metaInfo() {
    return {
      title: "Venue Events Lists",
    };
  },
  methods: {
    async fetchList() {
      const { data } = await this.$api.VenueEventsList.get({
        sort_by: this.sortBy,
      });
      this.list = data;
    },
    async destroy(item) {
      const confirmed = await this.$confirmWindow({ title: "Are you sure?" });
      if (!confirmed) return;
      await this.$api.VenueEventsList.destroy({ id: item.id });
      this.list = this.list.filter((t) => t.id != item.id);
    },
    async duplicate(item) {
      await this.$api.VenueEventsList.duplicate({ id: item.id });
      this.fetchList();
    },
  },
};
</script>

<style scoped lang="scss"></style>
